
export function getIdFromGoogleSpreadsheetUrl(url: string) {
  return url.split('/')[5]
}
